import React from "react";
import { Table } from "antd";

function SummaryTable({
  columns,
  data = [],
  loading = false,
  pagination = false,
  onChange,
  rowKey = "id",
  summary,
  bordered = false,
  scroll,
}) {
  return (
    <div className="summary-table-wrapper">
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={pagination}
        onChange={onChange}
        rowKey={rowKey}
        summary={summary}
        bordered={bordered}
        scroll={scroll}
      />
    </div>
  );
}

export default SummaryTable;